import styled from "styled-components";

const StyledErrorsModal = styled.div`
  padding: 10px 20px;
  .gdn-item {
    padding: 10px 0;
    &__panel {
      background-color: #ebedf2;
      border-radius: 6px;
      padding: 10px;
      margin-top: 10px;
      ol {
        margin-bottom: 10px;
        margin-left: 16px;
        li {
          list-style-type: decimal;
          margin: 5px 0;
        }
      }
    }
  }
`;

export default StyledErrorsModal;
